<template>
  <IonApp>
    <AppHeader v-if="showChrome" />

    <main class="app-content">
      <OfflineBanner />
      <IonRouterOutlet />
    </main>

    <BottomNav v-if="showChrome" />

    <!-- Global: AI page (or anywhere) opens via the Pinia bus -->
    <AiTaskConfirmSheet />
    <ConfirmDialog />
  </IonApp>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useRoute } from "vue-router"
import { IonApp, IonRouterOutlet } from "@ionic/vue"
import AppHeader from "@/components/chrome/AppHeader.vue"
import BottomNav from "@/components/chrome/BottomNav.vue"
import OfflineBanner from "@/components/OfflineBanner.vue"
import AiTaskConfirmSheet from "@/components/AiTaskConfirmSheet.vue"
import ConfirmDialog from "@/components/ConfirmDialog.vue"
import { useAuthStore } from "@/stores/auth"

const route = useRoute()
const auth = useAuthStore()

const showChrome = computed(() => {
  if (!auth.isAuthenticated) return false
  return !["login", "register", "not-found"].includes(route.name as string)
})
</script>
